export default __webpack_public_path__ + "static/media/4.23a22ab5.webp";